import {getUrlParam, setOrDeleteStringParam} from '@hconnect/common/utils'
import moment from 'moment-timezone'
import {useState} from 'react'
import {useSearchParams} from 'react-router'

import {TabTypeDto} from '../types'

import {useEditKpisModalState} from './useEditKpisModalState'

const SlaTrackingPageParams = {
  SLA_TAB_TYPE: 'tabType',
  SLA_YEAR: 'year'
}

const DEFAULT_SLA_TAB_TYPE = undefined

type SlaViewStateOptions = {
  timezone: string
}

export const useSlaTrackingPageState = ({timezone}: SlaViewStateOptions) => {
  const slaViewState = useSlaViewState({timezone})
  const commentsModalState = useCommentsModalState()
  const editKpisModalState = useEditKpisModalState()

  return {
    ...slaViewState,
    ...commentsModalState,
    ...editKpisModalState
  }
}

const useCommentsModalState = () => {
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false)

  const openCommentsModal = () => setIsCommentsModalOpen(true)
  const closeCommentsModal = () => setIsCommentsModalOpen(false)

  return {
    isCommentsModalOpen,
    openCommentsModal,
    closeCommentsModal
  }
}

const useSlaViewState = ({timezone}: SlaViewStateOptions) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const defaultYear = moment.tz(timezone).year()
  const year = getUrlParam(searchParams, SlaTrackingPageParams.SLA_YEAR, Number) ?? defaultYear
  const tabTypeParam = getUrlParam(searchParams, SlaTrackingPageParams.SLA_TAB_TYPE)
  const tabType = isTabType(tabTypeParam) ? tabTypeParam : DEFAULT_SLA_TAB_TYPE

  const setTabType = (value?: string) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, SlaTrackingPageParams.SLA_TAB_TYPE, value)
    setSearchParams(newParams)
  }

  const setYear = (value?: string) => {
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, SlaTrackingPageParams.SLA_YEAR, value)
    setSearchParams(newParams)
  }

  return {tabType, setTabType, year, setYear}
}

const isTabType = (value: string | undefined): value is TabTypeDto =>
  Object.values(TabTypeDto).includes(value as TabTypeDto)
